import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Flex, IconButton, Link as ChakraLink, mode, Text, useColorMode } from '@abb/uikit';
import { Menu02 } from '@abb/uikit/icons/outline/general';
import { XClose } from '@abb/uikit/icons/solid/general';
import { useDependencies, useLoyaltyCheckMember } from 'hooks';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { AbbLogo } from 'shared-components/abb-logo';
import { LoyaltyMemberStatus } from '../models';
import { DigitalBridgeMenu } from './DigitalBridgeMenu';
import { Point } from './FaydaPoint';
import { Notification } from './Notification';
import { UserSettings } from './user-settings/index';
export function Header(param) {
    let { isLargerThanMd, onSidebarOpen, isSidebarOpen, isSomeApps } = param;
    var _userService_getUserData;
    const { t } = useTranslation('common');
    const { userService } = useDependencies();
    const { colorMode } = useColorMode();
    const { data } = useLoyaltyCheckMember();
    const shouldDisplayPointStatuses = [
        LoyaltyMemberStatus.ACTIVE_MEMBER,
        LoyaltyMemberStatus.FROZEN_ACTIVE_MEMBER,
        LoyaltyMemberStatus.INACTIVE_MEMBER
    ];
    React.useEffect(()=>{
        document.getElementsByTagName('body')[0].style.backgroundColor = colorMode === 'light' ? 'white' : '#171923';
    }, [
        colorMode
    ]);
    return /*#__PURE__*/ _jsxs(Box, {
        as: "header",
        position: "sticky",
        zIndex: 10,
        top: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: {
            base: 4,
            md: isSomeApps ? 0 : 6
        },
        py: 6,
        bgColor: mode('#F0F0F0', '#0A0B0D')({
            colorMode
        }),
        w: "100%",
        height: {
            base: '72px',
            md: 'auto'
        },
        children: [
            /*#__PURE__*/ _jsx("div", {
                children: !isLargerThanMd ? /*#__PURE__*/ _jsx(ChakraLink, {
                    as: Link,
                    to: "/dashboard",
                    display: "block",
                    width: !isSomeApps && '100%',
                    marginRight: isSomeApps && 'auto',
                    height: "36px",
                    children: /*#__PURE__*/ _jsx(AbbLogo, {})
                }) : /*#__PURE__*/ _jsxs(Text, {
                    fontSize: "24px",
                    fontWeight: 500,
                    children: [
                        /*#__PURE__*/ _jsx(Box, {
                            as: "span",
                            mr: 3,
                            children: "\uD83D\uDC4B"
                        }),
                        t('welcome'),
                        " ",
                        userService === null || userService === void 0 ? void 0 : (_userService_getUserData = userService.getUserData) === null || _userService_getUserData === void 0 ? void 0 : _userService_getUserData.firstName,
                        "!"
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(Flex, {
                gap: {
                    base: 4,
                    md: 5
                },
                h: "fit-content",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ _jsxs(Flex, {
                        h: "fit-content",
                        gap: {
                            base: 4,
                            md: '28px'
                        },
                        pr: "30px",
                        borderRight: "1px",
                        borderColor: "#0A0B0D14",
                        children: [
                            !isSidebarOpen && (shouldDisplayPointStatuses === null || shouldDisplayPointStatuses === void 0 ? void 0 : shouldDisplayPointStatuses.includes(data)) && /*#__PURE__*/ _jsx(Point, {
                                loyaltyStatus: data
                            }),
                            !isSidebarOpen && isLargerThanMd && /*#__PURE__*/ _jsx(DigitalBridgeMenu, {
                                isLargerThanMd: isLargerThanMd,
                                isSomeApps: isSomeApps
                            }),
                            (isLargerThanMd || !isLargerThanMd && !isSidebarOpen) && !isSomeApps && /*#__PURE__*/ _jsx(Notification, {})
                        ]
                    }),
                    !isLargerThanMd && !isSomeApps && /*#__PURE__*/ _jsx(IconButton, {
                        ml: isSidebarOpen && 'auto',
                        bgColor: mode('#F2F2F7', '#282829')({
                            colorMode
                        }),
                        _hover: {
                            background: mode('#f7fafc', 'rgba(41, 41, 41, 0.90)')({
                                colorMode
                            })
                        },
                        icon: isSidebarOpen ? /*#__PURE__*/ _jsx(XClose, {
                            width: "20px",
                            height: "20px",
                            color: mode('#2D3748', 'white')({
                                colorMode
                            })
                        }) : /*#__PURE__*/ _jsx(Menu02, {
                            width: "20px",
                            height: "20px",
                            color: mode('#2D3748', 'white')({
                                colorMode
                            })
                        }),
                        "aria-label": "menu",
                        isRound: true,
                        onClick: onSidebarOpen
                    }),
                    isLargerThanMd && /*#__PURE__*/ _jsx(UserSettings, {
                        isLargerThanMd: true
                    })
                ]
            })
        ]
    });
}
